export const ORANGE = "#F27E33";
export const NAVY   = "#1D2946";

export const CITIES = [
  {
    key: "bogota",
    label: "Bogotá D.C.",
    lat: 4.7110,
    lng: -74.0721,
    zoom: 11,
    tag: "Oficina Principal",
    responseHrs: 24,
services: ["Obra civil","Acabados","Comunicaciones","Mobiliario","Mantenimiento locativo",
  "Hidrosanitarios","Sistemas eléctricos","Espacios públicos","Gas natural","Vidrio y aluminio"],  },
  {
    key: "medellin",
    label: "Medellín",
    lat: 6.25184,
    lng: -75.56359,
    zoom: 12,
    tag: "Cobertura",
    responseHrs: 48,
services: ["Obra civil","Acabados","Comunicaciones","Mobiliario","Mantenimiento locativo",
  "Hidrosanitarios","Sistemas eléctricos","Espacios públicos","Gas natural","Vidrio y aluminio"],  },
  {
    key: "cali",
    label: "Cali",
    lat: 3.45164,
    lng: -76.53198,
    zoom: 12,
    tag: "Cobertura",
    responseHrs: 48,
services: ["Obra civil","Acabados","Comunicaciones","Mobiliario","Mantenimiento locativo",
  "Hidrosanitarios","Sistemas eléctricos","Espacios públicos","Gas natural","Vidrio y aluminio"],  },
  {
    key: "barranquilla",
    label: "Barranquilla",
    lat: 10.96854,
    lng: -74.78132,
    zoom: 12,
    tag: "Cobertura",
    responseHrs: 48,
services: ["Obra civil","Acabados","Comunicaciones","Mobiliario","Mantenimiento locativo",
  "Hidrosanitarios","Sistemas eléctricos","Espacios públicos","Gas natural","Vidrio y aluminio"],  },
  {
    key: "cartagena",
    label: "Cartagena",
    lat: 10.39105,
    lng: -75.47943,
    zoom: 12,
    tag: "Cobertura",
    responseHrs: 48,
services: ["Obra civil","Acabados","Comunicaciones","Mobiliario","Mantenimiento locativo",
  "Hidrosanitarios","Sistemas eléctricos","Espacios públicos","Gas natural","Vidrio y aluminio"],  },
  {
    key: "bucaramanga",
    label: "Bucaramanga",
    lat: 7.12539,
    lng: -73.1198,
    zoom: 12,
    tag: "Cobertura",
    responseHrs: 48,
    services: ["Obra civil","Acabados","Comunicaciones","Mobiliario","Mantenimiento locativo",
  "Hidrosanitarios","Sistemas eléctricos","Espacios públicos","Gas natural","Vidrio y aluminio"],
  },
  
];

export const SERVICES = [
  "Obra civil","Acabados","Comunicaciones","Mobiliario","Mantenimiento locativo",
  "Hidrosanitarios","Sistemas eléctricos","Espacios públicos","Gas natural","Vidrio y aluminio"
];
